import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-willcall-activation-modal',
  templateUrl: './willcall-activation-modal.component.html',
  styleUrls: ['./willcall-activation-modal.component.css']
})
export class WillcallActivationModalComponent implements OnInit, OnDestroy {
  @Input() trip: any;
  @Output() onCloseModal = new EventEmitter<any>();

  tripForm: FormGroup;
  user;
  timeZone;
  constructor(
    private assignTripService: AssigTripsService,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService,
  ) { }


  ngOnInit() {
    this.tripForm = this.fb.group({
      companyNote: [''],
      isWillCallActivated: [true],
      preScheduleTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],
      appointmentTime: ['']
    });

    this.getUser();

  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.company ? this.user.company.timeZone : this.user.timeZone;

          const time = moment().tz(this.timeZone).add(45, 'minutes')
          this.tripForm.patchValue({
            preScheduleTime: time,
            scheduleTime: time.toISOString(),
            appointmentTime: time.toISOString(),
          })

        }
      });
  }

  onWillCallDateChange(evt) {
    this.tripForm.patchValue({
      scheduleTime: moment(evt).tz(this.timeZone, true).toISOString(),
      appointmentTime: moment(evt).tz(this.timeZone, true).toISOString(),
    });
  }

  async save() {
    const scheduleTime = this.tripForm.get('scheduleTime').value;
    if (scheduleTime && this.trip.jobOriginLatitude && this.trip.jobDestinationLatitude) {
      const queryParams = {
        start: [this.trip.jobOriginLongitude, this.trip.jobOriginLatitude].toString(),
        end: [this.trip.jobDestinationLongitude, this.trip.jobDestinationLatitude].toString(),
      };

      try {
        const result: any = await this.assignTripService.calculateMiles(queryParams).toPromise();

        if (result && result.features && result.features.length > 0) {
          let duration = 60;
          if (
            result &&
            result.features &&
            result.features[0] &&
            result.features[0].properties &&
            result.features[0].properties.segments &&
            result.features[0].properties.segments[0] &&
            result.features[0].properties.segments[0].duration
          ) {
            duration = result.features[0].properties.segments[0].duration / 60;
          }

          console.log('duration', duration);

          const estimatedAppointmentTime = moment(scheduleTime)
            .add(duration, 'minutes')
            .toISOString();

          this.tripForm.patchValue({
            appointmentTime: estimatedAppointmentTime
          });
        }
      } catch (error) {
        console.error('Error calculating miles:', error);
      }

      const payload = {
        ...this.tripForm.value,
        companyNote:
          this.tripForm.value.companyNote &&
          `${this.trip.companyNote}\nWill Call Notes:\n${this.tripForm.value.companyNote}\nAdded By:\n${this.user.displayName} - ${moment().tz(this.timeZone).format('MM-DD-YYYY HH:mm')}`,
        _id: this.trip._id
      };

      this.assignTripService.UpdateTripStatusWithNgrx(payload).subscribe((data) => {
        if (data) {
          this.onCloseModal.emit(data);
        }
      });
    }
  }


  close() {
    this.onCloseModal.emit();
  }
  ngOnDestroy() {
  }
}
